import { useEffect } from 'react';
import { useAnalytics } from './useAnalytics';
import { AnalyticsEvent } from '../constants/analyticsEvents';
import { detectAIAgent, isAIAgent } from '../../utils/detect-ai-agent';

/**
 * Hook to detect and track AI agent/LLM crawlers
 * Automatically identifies AI agents and tracks PAGE_CRAWLED event
 */
export const useAIAgentTracking = () => {
  const { trackEvent, setUserProperties } = useAnalytics();

  useEffect(() => {
    const aiAgent = detectAIAgent();
    trackEvent(AnalyticsEvent.PAGE_CRAWLED, {
      aiAgentType: aiAgent,
      userAgent: navigator.userAgent,
      pageUrl: window.location.href,
      timestamp: new Date().toISOString(),
    });
    if (aiAgent) {
      // Set user properties to identify the AI agent type
      setUserProperties({
        isAIAgent: true,
        aiAgentType: aiAgent,
      });

      // Track the page crawl event
    } else {
      // Set user property to indicate this is not an AI agent
      setUserProperties({
        isAIAgent: false,
      });
    }
  }, [trackEvent, setUserProperties]);

  return {
    isAIAgent: isAIAgent(),
    aiAgentType: detectAIAgent(),
  };
};
